import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const links = [
  { to: '/', label: 'Tableau de bord', icon: '⌂' },
  { to: '/riddles', label: 'Énigmes', icon: '◈' },
  { to: '/equivalence-rules', label: 'Règles d’équivalence', icon: '≋' },
  { to: '/imports', label: 'Imports', icon: '⇩' },
  { to: '/releases', label: 'Publications', icon: '↑' },
  { to: '/catalogues', label: 'Référentiels', icon: '▦' },
  { to: '/admins', label: 'Administrateurs', icon: '♙' },
];

export function AppShell() {
  const { user, staff, signOut } = useAuth();

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand-block">
          <div className="brand-mark">F</div>
          <div>
            <strong>Findex</strong>
            <span>Administration</span>
          </div>
        </div>

        <nav className="sidebar-nav" aria-label="Navigation principale">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              <span aria-hidden="true">{link.icon}</span>
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="account-summary">
            <strong>{user?.email ?? 'Compte'}</strong>
            <span>{staff?.role}</span>
          </div>
          <button className="button ghost full" onClick={() => void signOut()}>
            Se déconnecter
          </button>
        </div>
      </aside>

      <div className="main-column">
        <header className="topbar">
          <span>Gestion du contenu de production</span>
          <span className="environment-pill">Supabase · Production</span>
        </header>
        <main className="page-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
